// extracted by mini-css-extract-plugin
export default {"loadingSVG":"loading_loadingSVG__B9vou","spinner":"loading_spinner__rbLlz"};